<svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g>
		<rect x="0.5" y="1.24609" width="21" height="21" rx="10.5" stroke="currentColor" fill="none" />
		<path
			d="M11.364 17.0491C12.66 17.0491 13.704 16.2571 14.028 14.7271H15.306C14.91 16.9051 13.38 18.2011 11.364 18.2011C9.168 18.2011 7.602 16.6351 7.134 13.7731H6V12.6931H7.026C7.008 12.4591 7.008 12.2251 7.008 11.9731C7.008 11.7391 7.008 11.5051 7.026 11.2891H6V10.2091H7.134C7.584 7.31112 9.168 5.74512 11.364 5.74512C13.38 5.74512 14.91 7.04112 15.306 9.21912H14.028C13.704 7.68912 12.66 6.89712 11.364 6.89712C9.834 6.89712 8.718 7.97712 8.34 10.2091H12.138V11.2891H8.232C8.214 11.5051 8.214 11.7391 8.214 11.9731C8.214 12.2251 8.214 12.4591 8.232 12.6931H12.138V13.7731H8.358C8.736 15.9691 9.834 17.0491 11.364 17.0491Z"
			fill="currentColor"
		/>
	</g>
</svg>
